export default __webpack_public_path__ + "static/media/qrcode.464f21e3.svg";